<template>
  <div class="articoli-joomla-container" v-if="articoli.length > 0">
    <div v-if="showTitle" class="title">
      {{ intl[$store.state.lang]["related-questions"] }}
    </div>
    <baseLoader v-if="articoloLoader"></baseLoader>  
    <div v-else class="lista-articoli">
      <div v-for="(articolo, i) in articoli" :key="i">
        <div class="articolo">
          <h3 style="font-size: 16px; color:#008c95"><a :href="getArticoloUrl(articolo)">{{ articolo.core_title }}</a></h3>
          <div v-html="articoloCoreBodyConLinkAssoluti(articolo.core_body)" class="articolo-html"></div>
          <div class="link-documento-completo">[<a target=”_blank” :href="getArticoloUrl(articolo)">...</a>]</div>
          <div class="d-flex justify-content-center">
            <button class="documento-completo-button btn" :onClick="() => {openFullDocument(articolo)}">{{ intl[$store.state.lang]["read-all"] }}</button>
          </div>
          
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue"
import { apiUrls } from "../../api/apiUrls";
export default {
  name: "articoloJoomla",
  components: {
    "baseLoader": BaseLoader,
  },
  props: {
    setPaginaLoaderCallback: {
        type: Function,
        default: (value) => {return},
      },
    answerId: {
      type: Number,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    
    renderComponent: {
      type: Boolean,
      default: true,
    },
    onLoadDataEnded: {
      type: Function,
      default: (response,tags,articoli) => {
        console.log("Caricamento dati finito");
      },
    },
    onLoadDataStarted: {
      type: Function,
      default: () => {
        console.log("Caricamento dati iniziato");
      },
    },
  },

  created() {
    if (this.answerId) {
      this.getArticoliJoomla();
    }
  },
  computed: {
    baseUrlArticoli(){
      if(this.$store?.state?.libraryWiperConfig?.joomlaArticoloBasePath){
        return this.$store?.state?.libraryWiperConfig?.joomlaArticoloBasePath
      }else if(process.env.VUE_APP_JOOMLA_ARTICOLO_BASE_PATH){
        return process.env.VUE_APP_JOOMLA_ARTICOLO_BASE_PATH
      }
      return ""
    }
  },

  data: function () {
    return {
      intl: intl,
      test: true,
      articoloLoader: false,
      articoli: [],
      tags: []
    };
  },
  methods: {
    articoloCoreBodyConLinkAssoluti(body) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(body, 'text/html');
      let baseUrl = this.baseUrlArticoli
      if(baseUrl.endsWith('/')){
        baseUrl =  baseUrl.slice(0, -1)
      }
      const links = doc.querySelectorAll('a');

      links.forEach(link => {
        if (link.getAttribute('href') && !link.getAttribute('href').startsWith('http')) {
          if(!link.getAttribute('href').startsWith('/')){
            link.setAttribute('href', baseUrl + '/' + link.getAttribute('href'));
          }else{
            link.setAttribute('href', baseUrl + link.getAttribute('href'));
          }
          
        }
      });
      return doc.body.innerHTML;
    },

    getArticoloUrl(articolo){
      if(process.env.VUE_APP_IS_JOOMLA_5?.toLowerCase() === 'true' ||  this.$store?.state?.libraryWiperConfig?.isJoomla5?.toLowerCase() === 'true'){
        return this.baseUrlArticoli + '/risposte-assistenza/'+articolo.core_alias
      }else {
        return this.baseUrlArticoli + '/risposte-assistenza/'+articolo.content_item_id +'-'+articolo.core_alias
      }
    },
    openFullDocument(articolo){
      var url = this.baseUrlArticoli + '/risposte-assistenza/'+articolo.content_item_id +'-'+articolo.core_alias;
      if(process.env.VUE_APP_IS_JOOMLA_5?.toLowerCase() === 'true' ||  this.$store?.state?.libraryWiperConfig?.isJoomla5?.toLowerCase() === 'true'){
        url = this.baseUrlArticoli + '/risposte-assistenza/'+articolo.core_alias;
      }
      window.open(url, '_blank');
    },

    async getArticoliJoomla() {
      await this.getAnswerDetail();
      if(this.tags.length > 0){
        let queryTags = this.tags.map(function(tag) {
            return "titles[]=" + encodeURIComponent(tag);
        }).join('&');
        axios
          .get(apiUrls["joomla_contents_from_tag_titles"] + '?' + queryTags)
          .then((response) => {
            if(response?.data){
              this.articoli = response.data
            }
            this.onLoadDataEnded(response,this.articoli)
            this.articoloLoader = false;
          })
          .catch((error) => {
            this.onLoadDataEnded(error,this.articoli)
            this.articoloLoader = false;
          });
      }else{
        this.onLoadDataEnded(null,[])
        this.articoloLoader = false;
      }
    },

    async getAnswerDetail() {
      if (this.answerId) {
        this.articoloLoader = true;
        this.onLoadDataStarted()
        await axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {

            if (
              response.data &&
              response.data.answerTag &&
              response.data.answerTag.length > 0
            ) {
              response.data.answerTag.map((answerTag) => {
                if (answerTag.tag) {
                  this.tags.push(answerTag.tag);
                }
              });
            }

          })
          .catch((error) => {
            this.onLoadDataEnded(error,[])
            this.articoloLoader = false;
          });
      }
    },
  },
  watch: {
    articoloLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({articoloLoader: newValue})
                    }                
                },
                deep : true
        },
    answerId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getArticoliJoomla();
      }
    },
  },
  
};
</script>
